import { Navigate } from 'react-router-dom'

import { hasAnyPermission, hasPermission } from '@/features/permissions/hasPermission.ts'
import type { Permission } from '@/features/permissions/permissions.env.ts'
import { usePermissionsStore } from '@/features/permissions/usePermissions.store.ts'

type Props = {
	permissions: Permission[]
	children: React.ReactNode
	/** `every` — все перечисленные права; `some` — хотя бы одно. */
	match?: 'every' | 'some'
}

export function PermissionGuard({ permissions, children, match = 'every' }: Props) {
	const userPermissions = usePermissionsStore(state => state.permissions)

	const allowed =
		match === 'some' ? hasAnyPermission(userPermissions, permissions) : hasPermission(userPermissions, permissions)

	if (!allowed) {
		return <Navigate to='/403' replace />
	}

	return children
}
